import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dragonpay-proc-become-unavailable',
  templateUrl: './dragonpay-proc-become-unavailable.component.html',
  styleUrls: ['./dragonpay-proc-become-unavailable.component.scss']
})
export class DragonpayProcBecomeUnavailableComponent implements OnInit {

	@Input() onClose: any = null;
	@Input() selectedDragonpayProc: any = null;

	days:any = null;

	constructor() { }

	ngOnInit(): void {
		let daysOfWeek:any = this.selectedDragonpayProc.dayOfWeek.toLowerCase();
		daysOfWeek = this.selectedDragonpayProc.dayOfWeek.split("");
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		let newDays = [];
		daysOfWeek.forEach((val, key) => {
			val = val.toLowerCase();
			newDays.push({
				day_name: days[key],
				isAvailable: val == "x" ? true : false 
			});
		});

		this.days = newDays;
	}

	twelveHrsFormat(time) {
		// Check correct time format and split into components
		time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
	  
		if (time.length > 1) { // If time format correct
		  time = time.slice (1);  // Remove full string match value
		  time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
		  time[0] = +time[0] % 12 || 12; // Adjust hours
		}
		return time.join (''); // return adjusted time or original string
	}

	close(){
		this.onClose();
	}
}
